/** @format */

import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Table from "../../../extra/Table";
import Pagination from "../../../extra/Pagination";
import { getSellerTransition, markEarningFraud } from "../../../store/seller/seller.action";
import Analytics from "../../../extra/Analytics";
import { getSetting } from "../../../store/setting/setting.action";
import { formatAmount } from "../../../extra/functions";

const Transition = (props) => {
	const { sellerTransition, totalTransitions, sellerTransitionTotal, sellerTransitionSummary } = useSelector((state) => state.seller);
	console.log("sellerTransition-----", sellerTransition);

	const { defaultCurrency } = useSelector((state) => state.currency);
	const { setting } = useSelector((state) => state.setting);
	console.log("settings++", setting);

	const { state } = useLocation();
	const id = state;
	console.log("id+++++++++++++++++++", id);

	const dispatch = useDispatch();

	// Only 2 pagination states needed (removed redundancy)
	const [currentPage, setCurrentPage] = useState(1);
	const [rowsPerPage, setRowsPerPage] = useState(10);

	// Filter states
	const [data, setData] = useState([]);
	const [startDate, setStartDate] = useState("All");
	const [endDate, setEndDate] = useState("All");
	const [transactionType, setTransactionType] = useState("All");
	console.log("transactionType", transactionType);

	// API call with optimized parameters
	useEffect(() => {
		let transactionTypeValue;

		if (transactionType === "Earning") {
			transactionTypeValue = 1;
		} else if (transactionType === "Withdrawal") {
			transactionTypeValue = 2;
		} else {
			transactionTypeValue = "All";
		}
		dispatch(getSellerTransition(currentPage, rowsPerPage, startDate, endDate, id, transactionTypeValue));
		dispatch(getSetting());
	}, [dispatch, id, startDate, endDate, currentPage, rowsPerPage, transactionType]);

	useEffect(() => {
		setData(sellerTransition);
	}, [sellerTransition]);

	// Simplified pagination handlers
	const handleChangePage = (event, newPage) => {
		setCurrentPage(newPage); // Only one state to update
	};

	const handleChangeRowsPerPage = (event) => {
		const newRowsPerPage = parseInt(event, 10);
		setRowsPerPage(newRowsPerPage); // Only one state to update
		setCurrentPage(1); // Reset to page 1
	};

	const changeTransactionType = (value) => {
		setTransactionType(value);
		setStartDate("All");
		setEndDate("All");
	};

	// Re-fetch the current page of transactions (used after marking fraud).
	const refetchTransactions = () => {
		let transactionTypeValue;
		if (transactionType === "Earning") {
			transactionTypeValue = 1;
		} else if (transactionType === "Withdrawal") {
			transactionTypeValue = 2;
		} else {
			transactionTypeValue = "All";
		}
		dispatch(getSellerTransition(currentPage, rowsPerPage, startDate, endDate, id, transactionTypeValue));
	};

	// Mark / unmark an earning as fraud. Reverses the seller's earning for that
	// order out of their wallet (or restores it when unmarking).
	const handleToggleFraud = (row) => {
		if (row.transactionType !== 1) return;
		if (row.isFraud) {
			if (!window.confirm(`Remove the fraud flag on order ${row.orderId || ""} and credit ${formatAmount(row.sellerEarning)} back to the seller?`)) return;
			dispatch(markEarningFraud(row._id, "", refetchTransactions));
			return;
		}
		if (!window.confirm(`Mark order ${row.orderId || ""} as fraud? This will deduct ${formatAmount(row.sellerEarning)} from the seller's wallet.`)) return;
		const reason = window.prompt("Reason for marking this earning as fraud (optional):", "") || "";
		dispatch(markEarningFraud(row._id, reason, refetchTransactions));
	};

	const mapData = [
		{
			Header: "No",
			width: "20px",
			Cell: ({ index }) => <span className=''>{(currentPage - 1) * rowsPerPage + index + 1}</span>,
		},

		{
			Header: "Order Id",
			body: "orderId",
			Cell: ({ row }) => (
				<div className=''>
					<p className='mb-0 fw-normal'>{row.orderId ? row.orderId : "-"}</p>
				</div>
			),
		},

		{
			Header: "Buyer Name",
			body: "buyerName",
			Cell: ({ row }) => (
				<div className=''>
					<p className='mb-0 fw-normal'>{row.buyerName ? row.buyerName : "-"}</p>
				</div>
			),
		},

		{
			Header: "Seller Name",
			body: "sellerName",
			Cell: ({ row }) => (
				<div className=''>
					<p className='mb-0 fw-normal'>{row.sellerName + "  " + row.lastName}</p>
				</div>
			),
		},

		{
			Header: "business Name",
			body: "businessName",
			Cell: ({ row }) => (
				<div className=''>
					<p className='mb-0 fw-normal'>{row.businessName ? row.businessName : "-"}</p>
				</div>
			),
		},

		{
			Header: "business Tag",
			body: "businessTag",
			Cell: ({ row }) => (
				<div className=''>
					<p className='mb-0 fw-normal'>{row.businessTag ? row.businessTag : "-"}</p>
				</div>
			),
		},

		{
			Header: "Transaction Type",
			body: "transactionType",
			Cell: ({ row }) => (
				<div className='d-flex justify-content-center'>
					<span className={`badge p-2 ${row.transactionType === 1 ? "badge-success" : "badge-warning"}`}>{row.transactionType === 1 ? "Earning" : "Withdrawal"}</span>
				</div>
			),
		},
		{
			Header: "Narration",
			body: "narration",
			Cell: ({ row }) => (
				<div className=''>
					<p className='mb-0 fw-normal'>{row.narration ? row.narration : "-"}</p>
				</div>
			),
		},
		// {
		//   Header: `Order Id`,
		//   body: "orderId",
		//   Cell: ({ row }) => (
		//     <div className="">
		//       <p className="mb-0 font-normal">
		//         {row.orderId}
		//       </p>
		//     </div>
		//   ),
		// },
		{
			Header: `Seller Earning (${setting?.currency?.currencyCode || ""})`,
			body: "sellerEarning",
			Cell: ({ row }) => (
				<div className=''>
					<p className='mb-0 font-normal'>{formatAmount(row.sellerEarning)}</p>
				</div>
			),
		},

		{
			Header: `Admin Earning (${setting?.currency?.currencyCode || ""})`,
			body: "adminAmount",
			Cell: ({ row }) => (
				<div className=''>
					<p className='mb-0 font-normal'>{formatAmount(row.adminEarning)}</p>
				</div>
			),
		},

		{
			Header: `Order Amount (${setting?.currency?.currencyCode || ""})`,
			body: "orderAmount",
			Cell: ({ row }) => (
				<div className=''>
					<p className='mb-0 font-normal'>{row.orderAmount ? formatAmount(row.orderAmount) : "-"}</p>
				</div>
			),
		},
		{
			Header: "Date and Time",
			body: "dateAndTime",
			Cell: ({ row }) => (
				<div className=''>
					<p className='mb-0 fw-normal'>{row.date ? row.date : "-"}</p>
				</div>
			),
		},
		{
			Header: "Fraud Action",
			body: "fraudAction",
			Cell: ({ row }) =>
				row.transactionType === 1 ? (
					<div className='d-flex flex-column align-items-center' style={{ gap: "4px" }}>
						{row.isFraud && (
							<span className='badge p-2' style={{ background: "#FEE2E2", color: "#B91C1C", fontWeight: 600 }} title={`${row.fraudReason ? `Reason: ${row.fraudReason}\n` : ""}${row.fraudMarkedByName ? `By: ${row.fraudMarkedByName}\n` : ""}${row.fraudMarkedAt ? `On: ${new Date(row.fraudMarkedAt).toLocaleString()}` : ""}`.trim() || "Marked as fraud"}>
								<i className='fa-solid fa-triangle-exclamation me-1' />
								Fraud
							</span>
						)}
						<button
							type='button'
							className='btn btn-sm'
							onClick={() => handleToggleFraud(row)}
							style={{
								borderRadius: "6px",
								padding: "4px 12px",
								fontSize: "12px",
								fontWeight: 600,
								border: `1px solid ${row.isFraud ? "#16A34A" : "#DC2626"}`,
								color: row.isFraud ? "#16A34A" : "#DC2626",
								background: "#fff",
								whiteSpace: "nowrap",
							}}>
							{row.isFraud ? "Undo Fraud" : "Mark Fraud"}
						</button>
					</div>
				) : (
					<span className='text-muted'>-</span>
				),
		},
	];

	return (
		<div>
			{/* Wallet reconciliation summary */}
			{sellerTransitionSummary && (
				<div className='card mt-4'>
					<div className='card-body'>
						{(() => {
							const s = sellerTransitionSummary;
							const cur = setting?.currency?.currencyCode || defaultCurrency?.symbol || "";
							const overDeducted = Number(s.overDeducted) || 0;
							const discrepancy = Number(s.discrepancy) || 0;
							const hasDiscrepancy = Math.abs(discrepancy) > 1 || Math.abs(overDeducted) > 1;
							const cards = [
								{ label: "Lifetime Earnings", value: s.lifetimeEarnings ?? Number(s.netPayout || 0) + Number(s.amountWithdrawn || 0), sub: "netPayout + amount withdrawn", color: "#16A34A" },
								{ label: "Ledger Withdrawn (Debits)", value: s.totalWithdrawn, sub: `${s.withdrawalCount} ledger debit${s.withdrawalCount === 1 ? "" : "s"}`, color: overDeducted > 1 ? "#DC2626" : "#E54A13" },
								{ label: "Actual Withdrawals", value: s.legitWithdrawn, sub: `${s.legitWithdrawalCount} request${s.legitWithdrawalCount === 1 ? "" : "s"} (completed)`, color: "#7C3AED" },
								{ label: "Correct Balance", value: s.correctBalance, sub: "Lifetime earnings − Actual withdrawals", color: "#334155" },
								{ label: "Available (netPayout)", value: s.netPayout, sub: "Stored on seller", color: hasDiscrepancy ? "#DC2626" : "#0EA5E9" },
							];
							return (
								<>
									<div className='d-flex justify-content-between align-items-center mb-3 flex-wrap' style={{ gap: "8px" }}>
										<h6 style={{ fontWeight: 700, color: "#0f172a", margin: 0 }}>Wallet Summary {cur ? `(${cur})` : ""}</h6>
										{hasDiscrepancy ? (
											<span className='badge p-2' style={{ background: "#FEE2E2", color: "#B91C1C", fontWeight: 600 }}>
												<i className='fa-solid fa-triangle-exclamation me-1' />
												{overDeducted > 1 ? `Over-deducted by ${formatAmount(overDeducted)}` : `Discrepancy: ${formatAmount(discrepancy)}`}
											</span>
										) : (
											<span className='badge p-2' style={{ background: "#DCFCE7", color: "#15803D", fontWeight: 600 }}>
												<i className='fa-solid fa-circle-check me-1' />
												Balance reconciles
											</span>
										)}
									</div>
									<div className='row g-3'>
										{cards.map((c) => (
											<div className='col-6 col-md-3' key={c.label}>
												<div style={{ border: "1px solid #e2e8f0", borderRadius: "10px", padding: "14px 16px", height: "100%" }}>
													<p style={{ margin: 0, fontSize: "12px", color: "#64748b", fontWeight: 500 }}>{c.label}</p>
													<p style={{ margin: "6px 0 2px", fontSize: "20px", fontWeight: 700, color: c.color }}>{formatAmount(c.value || 0)}</p>
													<p style={{ margin: 0, fontSize: "11px", color: "#94a3b8" }}>{c.sub}</p>
												</div>
											</div>
										))}
									</div>
									{hasDiscrepancy && <p style={{ margin: "12px 0 0", fontSize: "12px", color: "#B91C1C" }}>{overDeducted > 1 ? `The ledger shows ${formatAmount(s.totalWithdrawn)} withdrawn but the seller only made ${formatAmount(s.legitWithdrawn)} in actual withdrawal requests — an over-deduction of ${formatAmount(overDeducted)}. This is the historical double-posting bug; the seller is owed this amount back.` : "The available balance does not match the seller's earnings minus their actual withdrawals. Review the withdrawal entries below."}</p>}
								</>
							);
						})()}
					</div>
				</div>
			)}

			<div className='card mt-4'>
				<div className='card-body'>
					<div className='userMain'>
						{/* Header with Transaction Type Dropdown and Date Selector */}
						<div className='row mb-3'>
							{/* Left side - Transaction Type Dropdown */}
							<div className='col-6' style={{ display: "flex", alignItems: "center" }}>
								<div className='btn-group'>
									<button
										type='button'
										className='btn btnnewPrime dropdown-toggle'
										data-bs-toggle='dropdown'
										aria-expanded='false'
										style={{
											borderRadius: "8px",
											padding: "8px 24px",
											border: "1px solid #e2e8f0",
											background: "#fff",
										}}>
										{transactionType ? <span className='caret text-black'>{transactionType}</span> : <span className='caret text-capitalize'>Transaction Type</span>}
									</button>
									<ul className='dropdown-menu'>
										<li style={{ cursor: "pointer" }}>
											<a
												className='dropdown-item'
												href={() => false}
												onClick={() => changeTransactionType("All")}
												// onClick={() => setTransactionType("All")}
											>
												All
											</a>
										</li>
										<li style={{ cursor: "pointer" }}>
											<a
												className='dropdown-item'
												href={() => false}
												// onClick={() => setTransactionType("Earning")}
												onClick={() => changeTransactionType("Earning")}>
												Earning
											</a>
										</li>
										<li style={{ cursor: "pointer" }}>
											<a
												className='dropdown-item'
												href={() => false}
												// onClick={() => setTransactionType("Withdrawal")}
												onClick={() => changeTransactionType("Withdrawal")}>
												Withdrawal
											</a>
										</li>
									</ul>
								</div>
							</div>

							{/* Right side - Date Analytics */}
							<div className='col-6' style={{ display: "flex", justifyContent: "flex-end" }}>
								<Analytics analyticsStartDate={startDate} analyticsStartEnd={endDate} setAnalyticsStartDate={setStartDate} setAnalyticsEndDate={setEndDate} title={"Transaction"} />
							</div>
						</div>

						{/* Table */}
						<div className='tableMain mt-2' style={{ marginLeft: "7px", marginRight: "7px" }}>
							<Table
								data={data}
								mapData={mapData}
								serverPerPage={rowsPerPage} // Direct use
								serverPage={currentPage} // Direct use
								type={"server"}
							/>

							{/* Pagination */}
							<Pagination
								component='div'
								count={sellerTransitionTotal}
								type={"server"}
								onPageChange={handleChangePage}
								serverPerPage={rowsPerPage}
								totalData={sellerTransitionTotal}
								serverPage={currentPage} // Direct use
								setCurrentPage={setCurrentPage}
								onRowsPerPageChange={handleChangeRowsPerPage}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default connect(null, { getSellerTransition })(Transition);
